<template>
  <div class="dwp-space-y-4 dwp-mb-4" v-if="edit">
    <Editor
      ref="content"
      style="min-height: 75px"
      :data-cy="`input-library-${prop}`"
      class="dwp-block dwp-appearance-none dwp-bg-white dwp-rounded dwp-border dwp-border-gray-200 dwp-p-3 focus:dwp-outline-none focus:dwp-shadow-outline focus:dwp-border-gray-500 dwp-w-full sm:dwp-text-sm sm:dwp-leading-5 dwp-shadow-none focus:dwp-shadow-none dwp-border-gray-300 dwp-text-gray-600 dwp-placeholder-gray-500 focus:dwp-border-gray-300 focus:sdwp-hadow-outline-gray dwp-leading-normal"
      placeholder="Add a description to help you identify this list in the future."
      :content.sync="description"
    />
    <VButton
      @click.native="list[prop] = description; edit = false"
      :data-cy="`save-library-${prop}`"
    >Save</VButton>
    <VButton type="plain" @click.native="description = list[prop]; edit = false">Cancel</VButton>
  </div>

  <div class="dwp-flex dwp-items-center dwp-group" v-else>
    <div
      class="editor-content dwp-text-gray-600 dwp-text-sm"
      v-if="list.description"
      v-html="list.description"
      :data-cy="`library-${prop}`"
    ></div>

    <div v-else class="dwp-text-gray-500 dwp-text-sm">No Description</div>

    <Edit2Icon
      class="dwp-w-4 dwp-h-4 dwp-cursor-pointer dwp-text-gray-400 dwp-ml-2 dwp-opacity-0 group-hover:dwp-opacity-100 dwp-transition-opacity dwp-duration-200"
      style="fill:none"
      :data-cy="`edit-library-${prop}`"
      @click.prevent="edit = true; description = list.description"
    />
  </div>
</template>

<script>
import VButton from "@/components/ui/VButton.vue";
import Editor from "@/components/shared/Editor.vue";
import { Edit2Icon } from "vue-feather-icons";

export default {
  components: {
    VButton,
    Edit2Icon,
    Editor,
  },

  props: {
    list: Object,
    prop: String,
  },

  data() {
    return {
      edit: false,
      description: "",
    };
  },

  mounted() {
    this;
  },
};
</script>